import React, { Component } from 'react';
import ExtendSessionHandler from 'smc-extendsession';
import Page from '../../lib/page';

class SessionHandler extends Component {
  constructor(props) {
    super(props);
    this.state = { data: window.localeBundle ? window.localeBundle.extendSession :
    {
      'extendSession.warningMessage': 'extendSession.warningMessage',
      'extendSession.logoutMessage': 'extendSession.logoutMessage',
      'extendSession.extendSessionBtnTxt': 'extendSession.extendSessionBtnTxt',
    } };
  }

  render() {
    if (!Page.isLoggedIn()) {
      return null;
    }
    return (<ExtendSessionHandler
      reLoginURL="/signin"
      extendSessionURL="/smarthelp/extendSession"
      warningMessage={this.state.data.extendSession.warningMessage}
      logoutMessage={this.state.data.extendSession.logoutMessage}
      extendSessionBtnTxt={this.state.data.extendSession.extendSessionBtnTxt}
    />);
  }
}

export default SessionHandler;



// WEBPACK FOOTER //
// ./contactUs/containers/SessionHandler.js